<template>
    <div :style="cssProps">
        <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
            <div class="row mb-2">
                <div class="col">
                    <h1 class="text-white pt-3 px-3">Drop Off 包裹统计</h1>
                    <p class="text-white pb-3 px-3">Drop Off 包裹统计描述</p>
                </div>
            </div>
        </base-header>
        <div class="text-center" v-if="busy">
            <BlockUI>
                <div class="loader"></div>
            </BlockUI>
        </div>
        <div class="container-fluid mt--8 mb-5">
            <div class="row">
                <div class="col">
                    <div class="card shadow py-5">
                        <div class="col-lg-12">
                            <h3 class="text-muted ml-4">ค้นหา</h3>
                            <div class="col-lg-12">
                                <b-form-group class="mb-0">
                                    <div class="row">

                                        <div class="col-lg-3 m-1">
                                            <input
                                                type="text"
                                                placeholder="请输入快递单号"
                                                class="form-control"
                                                v-model="search.pno"
                                            />
                                        </div>
                                        <div class="col-lg-3 m-1">
                                            <div class="col-lg m-1">
                                                <select class="form-control" v-model="search.pkgStatus">
                                                    <option value="" disabled selected>请选择订单状态</option>
                                                    <option value="2">网点已揽收</option>
                                                    <option value="4">快递员已揽收</option>
                                                    <option value="5">第三方揽收</option>
                                                    <option value="6">丢失包裹</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-lg-4 m-1">
                                            <div class="col-lg m-1">
                                                <date-range-picker
                                                    class="w-100"
                                                    :opens="'center'"
                                                    :min-date="minDate"
                                                    :max-date="maxDate"
                                                    :singleDatePicker="false"
                                                    :appendToBody="true"
                                                    :ranges="false"
                                                    :closeOnEsc="false"
                                                    :autoApply="true"
                                                    :locale-data="{ format: 'dd-mm-yyyy' }"
                                                    v-model="searchData">
                                                </date-range-picker>
                                            </div>
                                        </div>
                                    </div>
                                </b-form-group>
                                <div class="d-flex justify-content-start mt-4">
                                    <button class="btn btn-info btn-sm-res" @click="queryDropOffList(1)">
                                        <i class="fa fa-search"></i>查询
                                    </button>
                                    <button class="btn btn-outline-info btn-sm-res" @click="updatePkgStatus">
                                        更新包裹状态
                                    </button>
                                </div>
                                <div class="mt-3">
                                    <b-table
                                        ref="reportDelivery"
                                        show-empty
                                        responsive
                                        :items="dataList"
                                        :fields="fields"
                                        :per-page="search.perPage"
                                        :busy="busy"
                                        selectable
                                        select-mode="multi"
                                        @row-selected="onRowSelected"
                                        class="scroll-bar-pop text-center"
                                        empty-text="ไม่มีข้อมูล"
                                        empty-filtered-text="ไม่พบข้อมูลที่ต้องการค้นหา"
                                    >
                                        <template slot="HEAD_selected">
                                            <b-form-checkbox v-model="checkSelect" @change="selectAllRows"
                                                             class="text-center"></b-form-checkbox>
                                        </template>
                                        <template
                                            slot="selected"
                                            slot-scope="{ rowSelected }"
                                        >
                                            <template v-if="rowSelected">
                                                <div class="custom-control custom-checkbox">
                                                    <input type="checkbox" autocomplete="off" class="custom-control-input"
                                                           value="true" checked>
                                                    <label class="custom-control-label"></label>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <div class="custom-control custom-checkbox">
                                                    <input type="checkbox" autocomplete="off" class="custom-control-input"
                                                           value="false">
                                                    <label class="custom-control-label"></label>
                                                </div>
                                            </template>
                                        </template>

                                        <template slot="pkgStatus" slot-scope="data">
                                            <b-badge variant="status-parcel-success" v-if="data.item.pkgStatus == 2">网点已揽收</b-badge>
                                            <b-badge variant="status-parcel-success" v-else-if="data.item.pkgStatus == 4">快递员已揽收</b-badge>
                                            <b-badge variant="status-parcel-warning" v-else-if="data.item.pkgStatus == 5">第三方揽收</b-badge>
                                            <b-badge variant="status-parcel-danger" v-else-if="data.item.pkgStatus == 6">丢失包裹</b-badge>
                                        </template>
                                    </b-table>
                                </div>
                                <div class="mt-3">
                                    <b-pagination
                                        :total-rows="totalItem"
                                        :current-page="search.page"
                                        :per-page="search.perPage"
                                        :value="search.page"
                                        @input="changePage"
                                        align="right">
                                    </b-pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import {hexToRgbA} from "@/plugins/hexColor";
import moment from "moment";
import {queryDropOffList, updatePkgStatus} from "@/api/dropOff";

export default {
    name: "",
    data() {
        return {
            checkSelect: false,
            minDate: null,
            maxDate: moment().format("YYYY-MM-DD"),
            busy: false,
            search: {
                pkgStatus: '',
                pno: '',
                page: 1,
                perPage: 10,
            },
            searchData: {
                startDate: "",
                endDate: "",
            },
            dataList: [],
            fields: [
                {key: "selected", label: "เลือกรายการ", sortable: false, class: "text-center"},
                {
                    key: "pno",
                    label: "快递单号",
                    sortable: true,
                },
                {
                    key: "createTime",
                    label: "创建时间",
                    sortable: true,
                },
                {
                    key: 'dropOffPlatform',
                    label: '结算平台',
                    sortable: true,
                },
                {
                    key: "pkgStatus",
                    label: "订单状态",
                    sortable: true,
                },
                {
                    key: 'pickupTplSlug',
                    label: '第三方物流',
                    sortable: true,
                },
                {
                    key: "pickUpDate",
                    label: "网点揽收时间",
                    sortable: true,
                },
                {
                    key: "outboundedTime",
                    label: "网点交付时间",
                    sortable: true,
                },
            ],
            selected: [],
            totalItem: 0,
        }
    },
    created() {

    },
    mounted() {
        this.queryDropOffList()
    },
    methods: {
        updatePkgStatus() {
            updatePkgStatus().then(res => {
                this.$message.success(res.message)
            }).catch(() => {
                this.$message.error("更新失败")
            })
        },
        selectAllRows() {
            if(this.dataList.length < 1){
                return false
            }
            this.checkSelect = !this.checkSelect
            if(this.checkSelect){
                this.$refs.reportDelivery.selectAllRows()
            }else{
                this.$refs.reportDelivery.clearSelected()
            }
        },
        queryDropOffList(val) {
            if (val === 1) {
                this.search.page = 1;
            }
            this.busy = true;
            queryDropOffList({
                agentId: this.$store.state.loginUser.agentId,
                dropOffPlatform: 'LAZADA',
                pageIndex: this.search.page,
                pageSize: this.search.perPage,
                pnos: this.search.pno ? [this.search.pno] : undefined,
                pkgStatus: this.search.pkgStatus,
                startTime: this.searchData.startDate ? moment(this.searchData.startDate).format("YYYY-MM-DD") + ' 00:00:00' : undefined,
                endTime: this.searchData.endDate ? moment(this.searchData.endDate).format("YYYY-MM-DD") + ' 23:59:59' : undefined,
            }).then(res => {
                this.dataList = res.data.records;
                this.totalItem = res.data.total;
                this.busy = false;
            }).catch(() => {
                this.busy = false;
            })
        },
        changePage(i) {
            if (this.search.page == i) return;
            this.search.page = i
        },
        onRowSelected(items) {
            this.selected = items
        },
    },
    computed: {
        cssProps() {
            return {
                '--bg-hover-color': hexToRgbA('#11cdef', 0.7),
                '--bg-color': '#11cdef',
            }
        }
    }
};
</script>
<style scoped>

</style>
